export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);

  if (sec < 60) return "ahora";
  if (min < 60) return `hace ${min}m`;
  if (hr < 24) return `hace ${hr}h`;
  if (day < 7) return `hace ${day}d`;

  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function initials(name) {
  return (
    (name || "")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase())
      .join("") || "?"
  );
}

/**
 * Estados de una tarea del área de trabajo (espejo del backend WorkspaceTask).
 * El avance es hacia adelante y se puede reabrir una finalizada.
 */
export const TASK_STATUS = {
  CREATED: "created",
  IN_PROGRESS: "in_progress",
  FINISHED: "finished",
};

export const TASK_STATUS_ORDER = [
  TASK_STATUS.CREATED,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.FINISHED,
];

export const TASK_STATUS_META = {
  [TASK_STATUS.CREATED]: {
    label: "Creadas",
    single: "Creada",
    color: "#6b7280",
    bg: "rgba(107,114,128,0.12)",
  },
  [TASK_STATUS.IN_PROGRESS]: {
    label: "En curso",
    single: "En curso",
    color: "#1976d2",
    bg: "rgba(25,118,210,0.12)",
  },
  [TASK_STATUS.FINISHED]: {
    label: "Finalizadas",
    single: "Finalizada",
    color: "#2e7d32",
    bg: "rgba(46,125,50,0.14)",
  },
};

const ALLOWED_TRANSITIONS = {
  [TASK_STATUS.CREATED]: [TASK_STATUS.IN_PROGRESS],
  [TASK_STATUS.IN_PROGRESS]: [TASK_STATUS.FINISHED],
  [TASK_STATUS.FINISHED]: [TASK_STATUS.IN_PROGRESS],
};

export function nextStatuses(status) {
  return ALLOWED_TRANSITIONS[status] || [];
}

export function statusMeta(status) {
  return TASK_STATUS_META[status] || TASK_STATUS_META[TASK_STATUS.CREATED];
}

export function personName(person) {
  if (!person) return "";
  return `${person.name ?? ""} ${person.lastname ?? ""}`.trim() || person.name || "";
}
